<template>
  <form @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="GitlabIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg pt-4 leading-none">Dati Tutor</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mt-6">
      <vs-col class="md:w-2/12 w-full px-2 mt-4">
        <label class="vs-input--label">Tirocinanti seguiti</label>
        <vx-tooltip text="Escluso il presente">
          <vs-input type='number' :disabled="is_readonly" v-model="form.tutor_num_tir" class="w-full"/>
        </vx-tooltip>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2 mt-4">
        <label class="vs-input--label">Cognome</label>
        <vs-input v-model="form.tutor_cognome" :disabled="is_readonly" class="w-full" />
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2 mt-4">
        <label class="vs-input--label">Nome</label>
        <vs-input :disabled="is_readonly" v-model="form.tutor_nome" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2 mt-4">
        <label class="vs-input--label">Codice fiscale</label>
        <vs-input :disabled="is_readonly" v-model="form.tutor_cf" pattern="[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2 mt-4">
        <label class="vs-input--label">Telefono</label>
          <vs-input :disabled="is_readonly" v-model="form.tutor_tel" class="w-full"/>
        </vs-col>
        <vs-col class="md:w-3/12 w-full px-2 mt-4">
          <label class="vs-input--label">Ruolo in azienda</label>
          <vs-input :disabled="is_readonly" v-model="form.tutor_role" class="w-full"/>
        </vs-col>
        <vs-col class="md:w-3/12 w-full px-2 mt-4">
          <label class="vs-input--label">Tipo di contratto</label>
          <vs-select :disabled="is_readonly" class="w-full" v-model="form.tutor_contract_type">
            <vs-select-item v-for="(label, id) in $tir.contract_types" :key="id" :value="id" :text="label" />
          </vs-select>
        </vs-col>
        <vs-col class="md:w-3/12 w-full px-2 mt-4">
          <vx-tooltip v-if="form.tutor_contract_type == 'det'" text="Deve essere successiva alla data di termine del presente tirocinio">
            <label class="vs-input--label">Data fine contratto</label>
            <v-date typeable class="upsidedown w-full" :disabled="is_readonly" placeholder="Scegli la data"
            :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.tutor_contract_end"/>
          </vx-tooltip>
        </vs-col>
      </vs-row>
  </form>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  data () {
    return {
      is_saving: false,
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
  },

  // mounted () {
  //   if (!this.form.tutor_nome) {
  //     this.form.tutor_nome = this.form.tutor.name
  //   }
  //   if (!this.form.tutor_cognome) {
  //     this.form.tutor_cognome = this.form.tutor.surname
  //   }
  // },

  mounted() {
    if (!this.form.tutor_num_tir) {
      this.form['tutor_num_tir'] = 0
    }
  },

  methods: {
    save() {
      this.is_saving = true
      this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form).then(res => {
        this.$parent.$parent.nextTab()
      }).finally(res => {
        this.is_saving = false
      })
    },
  },

  watch: {
    'form.tutor_contract_type'(v) {
      if (v != 'det') this.form.tutor_contract_end = null
    },
  }
}
</script>

<style lang="css">
.upsidedown .vdp-datepicker__calendar {
  position: absolute;
  top: -222px;
}
</style>
